var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.404 20.362h2.004c.773 0 1.403-.536 1.403-1.194v-.249c1.212.526 3.966 1.443 8.445 1.443h1.283c1.857 0 3.435-1.131 3.752-2.687l.898-4.433c.19-.945-.118-1.906-.843-2.638-.724-.731-1.786-1.15-2.91-1.15H13.8a5.53 5.53 0 0 0 .453-2.216C14.252 4.678 12.548 4 11.647 4 9.982 4 9.842 5.32 9.842 6.557c0 1.509-1.99 2.763-3.042 3.321-.054-.617-.654-1.106-1.392-1.106H3.404C2.63 8.772 2 9.308 2 9.966v9.202c0 .66.63 1.194 1.404 1.194zm7.64-13.806c0-1.533.306-1.533.602-1.533.564 0 1.402.59 1.402 2.216 0 1.51-.695 2.436-.7 2.443a.446.446 0 0 0-.03.524c.104.167.31.27.53.27h4.586c.77 0 1.496.287 1.99.787.497.5.707 1.159.577 1.805l-.897 4.432c-.216 1.065-1.295 1.838-2.566 1.838h-1.283c-5.455.001-8.188-1.45-8.444-1.593v-6.689c.668-.3 4.234-2.026 4.234-4.499h-.001zM3.202 9.965c0-.094.09-.17.2-.17h2.005c.11 0 .2.076.2.17v9.203c0 .093-.091.171-.2.171H3.404c-.112 0-.201-.076-.201-.17V9.965l-.001-.001z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.b8a0aa398c1fbd895c1a17bcda30fccb.svg";
export { ForwardRef as ReactComponent };